export const GET_GEOFENCES = "GET_GEOFENCES";

export const ADD_GEOFENCE = "ADD_GEOFENCE";
export const EDIT_GEOFENCE = "EDIT_GEOFENCE";

export const SET_SELECTED_GEOID = "SET_SELECTED_GEOID";
export const CLEAR_SELECTED_GEOID = "CLEAR_SELECTED_GEOID";

export const SET_SELECTED_GEOFENCE_GEOID = "SET_SELECTED_GEOFENCE_GEOID";
export const CLEAR_SELECTED_GEOFENCE_GEOID = "CLEAR_SELECTED_GEOFENCE_GEOID";